import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Criterio } from 'src/app/_models/meta';
import { Observable } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { BotonCriterioGroupComponent } from '../boton-criterio-group/boton-criterio-group.component';

@Component({
  selector: 'app-retroalimentacion-criterio-control',
  standalone: false,
  templateUrl: './retroalimentacion-criterio-control.component.html',
  styleUrls: ['../retroalimentacion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetroalimentacionCriterioControlComponent implements OnInit, OnChanges {

  @Input()
  alumno: any;
  @Input()
  criterio: Criterio;
  @Input()
  eventoUnidadID: number;
  @Input()
  fecha$: Observable<string>;
  @Input()
  view: string;
  @Input()
  nivelForm: UntypedFormControl = new UntypedFormControl(0);
  @Input()
  alumnos$: Observable<any>;
  @Input()
  mostrarAutoevaluacion$: Observable<boolean>;

  @ViewChild('criterioGroup', {static: false}) criterioGroup: BotonCriterioGroupComponent;

  constructor(private globalService: GlobalService ) { }

  ngOnInit(): void {
    this.setNivel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alumno) {
      this.setNivel();
    }
  }

  setNivel() {
    if (this.criterio.niveles.length === 1) {
      this.nivelForm.setValue(this.criterio.niveles[0].id);
    } else {
      const criterios = this.alumno.criterios;
      if (criterios.length === 0) {
        this.nivelForm.setValue(this.criterio.niveles[0].id);
      } else {
        this.criterio.niveles.forEach(nivel => {
          const interseccion = this.globalService.intersectionArrays(
            nivel.criterios.map(item => item.id), this.alumno.criterios.map(item => item.criterioId));
          if (interseccion.length > 0) {
            this.nivelForm.setValue(nivel.id);
          }
        });
      }
      if (this.nivelForm.value === 0) {
        this.nivelForm.setValue(this.criterio.niveles[0].id);
      }
    }
  }

  limpiarFormYGuardar() {
    this.criterioGroup.limpiarFormYGuardar();
  }

}
